module.exports = __webpack_public_path__ + "img/no-radio.a08241a1.png";